import React from "react"
import { browserIsSupportedForProctoring } from "utils/constants"

import UnsupportedBrowserDialog from "../../Instructions/SystemRequirement/UnsupportedBrowserDialog"
import AttemptITOAssessment from ".."

const ITOAssessmentWrapper = () => {
  if (browserIsSupportedForProctoring === "supported") {
    return <AttemptITOAssessment />
  }

  return (
    <>
      <UnsupportedBrowserDialog open />
    </>
  )
}

export default ITOAssessmentWrapper
